export const validateVariantPricing = (variant) => {
    const errors = [];
    const mrp = parseFloat(variant.mrp) || 0;
    const price = parseFloat(variant.price) || 0;

    if (!variant.value) {
        errors.push("Value is required.");
    }
    
    if (mrp <= 0) {
        errors.push("MRP must be greater than 0.");
    }
    
    if (price <= 0) {
        errors.push("Selling Price must be greater than 0.");
    }

    if (mrp > 0 && price > 0) {
        const maxAllowedPrice = Math.floor(mrp * 0.8);
        if (price > maxAllowedPrice) {
            errors.push(`Selling Price (₹${price}) must be at least 20% below MRP (₹${mrp}). Max allowed: ₹${maxAllowedPrice}`);
        }
    }

    if (variant.stock === undefined || variant.stock === null || variant.stock === "") {
        errors.push("Stock is required.");
    }

    return errors;
};

export const validateVariantGroup = (group) => {
    const groupErrors = [];
    if (!group.name || group.name.trim() === "") {
        groupErrors.push("Variant Group Name is required.");
    }
    if (!group.variants || group.variants.length === 0) {
        groupErrors.push(`Group "${group.name || 'Unknown'}" must have at least one variant value.`);
    }
    
    let variantErrors = false;
    (group.variants || []).forEach(v => {
        if (validateVariantPricing(v).length > 0) {
            variantErrors = true;
        }
    });
    
    if (variantErrors) {
        groupErrors.push(`Please fix variant errors in group "${group.name || 'Unknown'}".`);
    }

    return groupErrors;
};
